export var linkDisabledMixin = function linkDisabledMixin() {
  return "\n    box-shadow: none;\n    cursor: default;\n  ";
};
export var linkUseColorsMixin = function linkUseColorsMixin(mainColor, hoverColor, activeColor) {
  return "\n    color: " + mainColor + ";\n\n    &:hover {\n      color: " + hoverColor + ";\n    }\n\n    &:active {\n      color: " + activeColor + ";\n    }\n  ";
};